module.exports = "https://img.zhijierongxing.com/saas/img/shop_itmbg.17c4984f.png";